<template>

    <nav>
 <img alt="logo" src="../assets/logo.png" height="100" class="" >
  <ul>
  </ul>
</nav>


</template>

<style>
@import '../assets/form.css';
</style>

<script>
import axios from 'axios'
export default {
  name: 'menu',
  props: {

  },
  data() {
    return {
      teamName: "",
      nameError: false,
      license: "",
      boxid: "",
      error: ""

    }
  },
  async mounted() {


    if (localStorage.getItem("license") !== null && localStorage.getItem("boxid") !== null) {
      this.license = localStorage.getItem("datadash-license")
      this.boxid = localStorage.getItem("datadash-boxid")
      await this.GameSetup()
    }
  },
  methods: {
    async GameSetup() {
      this.error = ""

      var setup = (await axios.post(process.env.VUE_APP_ip + '/gamesetup', { "license": this.license })).data
      if (setup.error) {
        console.log(setup.error)
        this.error = setup.error
      } else {
        localStorage.setItem('datadash-license', this.license);
        localStorage.setItem('datadash-boxid', this.boxid);
        this.$emit('dbidfu', setup.dbid)
        this.$emit('vidoePathSetup', setup.videoPath)
        this.$emit('langup', setup.language)
        this.$emit('langdata', setup.gameText)
        this.$emit('gamedata', setup.gameSettings)
        this.$emit('gameStages', setup.stages)
        this.$emit('updatestage', "")

        if (setup.gameSettings.customFont){
      var appObj = document.getElementById("app");
      appObj.style.fontFamily = setup.gameSettings.customFont;
    }
      }






    }
  }
}
</script>


